import { IUser } from "@/services/Models";
import { inject, InjectionKey, reactive, ref } from "vue";

export interface Claims {
  email: string;
  name: string;
  exp: number;
}

// 認証ストアを初期化
const authStore = () => {
  const iam = ref(undefined as IUser | undefined);
  const isLoggedin = ref(false);

  // 認証状態を初期化
  const state = reactive({
    isLoggedin: isLoggedin,
    iam: iam,
  });
  // 認証ユーザー情報を初期化
  const setUser = (user: IUser | undefined) => {
    if (user === undefined) {
      state.iam = undefined;
      state.isLoggedin = false;
      return;
    }
    state.isLoggedin = !!user;
    if (state.isLoggedin) {
      state.iam = user;
    }
  };
  const logout = () => setUser(undefined);

  return {
    state,
    setUser,
    logout,
  };
};

export default authStore;

export type AuthStore = ReturnType<typeof authStore>;

export const authStoreKey: InjectionKey<AuthStore> = Symbol("authStore");

export const useAuthStore = () => {
  const store = inject(authStoreKey);
  if (!store) {
    throw new Error(`${authStoreKey} is not provided`);
  }
  return store;
};
